module.exports = require("./fr-GF.js");